import { memo, useState } from "react";
import Logo from "@/public/icons/logo.svg";
import Image from "next/image";
import Telegram from "@/public/icons/telegram.svg";
import Phone from "@/public/icons/Phone_duotone.svg";
import styles from "../login-modal.module.css";
import { Spin } from "@/ui/spin";

export const FirstScreen = memo(
  ({
    isTelegramEnabled,
    onTelegramLogin,
    isPhoneEnabled,
    onPhoneLogin,
    isGuestEnabled,
    onGuestAuth
  }: {
    isTelegramEnabled: boolean;
    onTelegramLogin: () => void;
    isPhoneEnabled: boolean;
    onPhoneLogin: () => void;
    isGuestEnabled: boolean;
    onGuestAuth: () => void;
  }) => {
    const [isTelegramLoading, setIsTelegramLoading] = useState(false);
    return (
      <>
        <Image src={Logo} alt="logo" width={200} height={80} priority />
        <main className={styles.main}>
          {isGuestEnabled && <button
            className={styles.cardWrapper}
            onClick={onGuestAuth}
            disabled={isTelegramLoading}
          >

            <div>Войти как гость</div>
          </button>}
          {isTelegramEnabled && (
            <button
              className={styles.cardWrapper}
              onClick={() => { onTelegramLogin(); setIsTelegramLoading(true); }}
              disabled={isTelegramLoading}
            >
              {<Image
                src={Telegram}
                width={48}
                height={48}
                alt="telegram"
                priority
              />}
              <div>Войти через Telegram</div>
              {isTelegramLoading && <Spin size="large" />}
            </button>
          )}

          {isPhoneEnabled && (
            <button
              className={styles.cardWrapper}
              onClick={onPhoneLogin}
            >
              <Image src={Phone} width={48} height={48} alt="Телефон" priority />
              <div>Войти по номеру телефона</div>
            </button>
          )}
        </main>
      </>
    );
  }
);